import { render } from "./speeach_search.vue?vue&type=template&id=4fc5816f&scoped=true"
import script from "./speeach_search.vue?vue&type=script&lang=js"
export * from "./speeach_search.vue?vue&type=script&lang=js"

import "./speeach_search.vue?vue&type=style&index=0&id=4fc5816f&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc5816f"]])

export default __exports__